import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import { Interweave } from 'interweave';

import { HorizontalCarouselIcon } from './Layout/HorizontalCarouselIcon';
import { HorizontalCarouselImg } from './Layout/HorizontalCarouselImg';
import useConfigs from '../hooks/useConfigs';
import Hero from './HeroSection/Hero';
import { useApi } from '../hooks/useApi';
import useThemes from '../hooks/useThemes';
import { NavLink } from 'react-router-dom';

export const PageQuienesSomos = () => {
  const { fontSizeMultiplier } = useConfigs();
  const { quienesSomos, politicas, getQuienesSomos, getPoliticas } = useApi();
  const { data, isLoading } = quienesSomos;
  const {
    backgroundWhite,
    backgroundNoveno,
    colorPrincipal,
    colorSecundario,
    colorCuarto,
    colorQuinto,
  } = useThemes();

  const [isShown, setIsShown] = useState(false);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    getQuienesSomos();
    getPoliticas();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      fontsizemultiplier={fontSizeMultiplier}
      backgroundcontainer={backgroundWhite}
      colortitle={colorSecundario}
      colorsubtitle={colorPrincipal}
      colortipografia={colorCuarto}
    >
      <Hero
        title='¿Quiénes Somos?'
        subtitle=''
        imgSrc='img/Quienes-somos/seccion-quienes-somos.JPG'
        color={backgroundWhite}
      />

      <div className='nuestra-historia'>
        {isLoading ? (
          <div className='img-container'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='0' rx='30' ry='30' width='100%' height='100%' />
              <rect x='0' y='120%' rx='30' ry='30' width='100%' height='100%' />
            </ContentLoader>
          </div>
        ) : (
          <div className='img-container'>
            <img src={data.historia?.imagen} alt='Nuestra historia' />
          </div>
        )}
        {isLoading ? (
          <div className='text-container'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='0' rx='3' ry='3' width='50%' height='10' />
              <rect x='0' y='25' rx='3' ry='3' width='60%' height='25' />
              <rect x='0' y='70' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='90' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='110' rx='3' ry='3' width='90%' height='10' />
              <rect x='0' y='130' rx='3' ry='3' width='55%' height='10' />
            </ContentLoader>
          </div>
        ) : (
          <div className='text-container'>
            <p className='subtitle'>{data.historia?.texto_corto}</p>
            <h2 className='title'>{data.historia?.titulo}</h2>
            <p className='info'>
              <Interweave
                content={data.historia?.texto_completo?.split('\n')[0]}
              />
            </p>
          </div>
        )}
      </div>
      <div className='historia'>
        {isLoading ? (
          <ContentLoader
            speed={2}
            width='100%'
            height='30%'
            foregroundColor={colorSecundario}
            backgroundColor={colorQuinto}
          >
            <rect x='25%' y='0' rx='3' ry='3' width='50%' height='20' />
            <rect x='20%' y='30' rx='3' ry='3' width='60%' height='20' />
            <rect x='15%' y='60' rx='3' ry='3' width='70%' height='20' />
            <rect x='15%' y='90' rx='3' ry='3' width='70%' height='20' />
            <rect x='17.5%' y='120' rx='3' ry='3' width='65%' height='20' />
            <rect x='22.5%' y='150' rx='3' ry='3' width='55%' height='20' />
          </ContentLoader>
        ) : (
          <p>
            {
              data.historia?.texto_completo?.split('\n')[
                data.historia?.texto_completo?.split('\n').length - 1
              ]
            }
          </p>
        )}
      </div>

      <HorizontalCarouselIcon data={data.carruselUno} />
      <HorizontalCarouselImg data={data.carruselDos} />
      <div className='mision'>
        {isLoading ? (
          <div className='mision-img-container'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
              <rect x='0' y='120%' rx='30' ry='30' width='100%' height='100%' />
            </ContentLoader>
          </div>
        ) : (
          <div className='mision-img-container'>
            <img src={data.mision?.imagen} alt='Misión' />
          </div>
        )}
        {isLoading ? (
          <div className='mision-text-container'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='25' rx='3' ry='3' width='60%' height='25' />
              <rect x='0' y='70' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='90' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='110' rx='3' ry='3' width='90%' height='10' />
              <rect x='0' y='130' rx='3' ry='3' width='55%' height='10' />
            </ContentLoader>
          </div>
        ) : (
          <div className='mision-text-container'>
            <p className='mision-title'
              dangerouslySetInnerHTML={{
                __html: data.mision?.titulo,
              }}
            ></p>

            <p className='mision-info'
              dangerouslySetInnerHTML={{
                __html: data.mision?.texto_completo,
              }}
            ></p>
          </div>
        )}
      </div>
      <div className='vision'>
        {isLoading ? (
          <div className='vision-img-container vision-img-mobile'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
              <rect x='0' y='120%' rx='30' ry='30' width='100%' height='100%' />
            </ContentLoader>
          </div>
        ) : (
          <div className='vision-img-container vision-img-mobile'>
            <img src={data.vision?.imagen} alt='Visión' />
          </div>
        )}
        {isLoading ? (
          <div className='vision-text-container'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='25' rx='3' ry='3' width='60%' height='25' />
              <rect x='0' y='70' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='90' rx='3' ry='3' width='100%' height='10' />
              <rect x='0' y='110' rx='3' ry='3' width='90%' height='10' />
              <rect x='0' y='130' rx='3' ry='3' width='55%' height='10' />
            </ContentLoader>
          </div>
        ) : (
          <div className='vision-text-container'>
            <p className='vision-title'
            dangerouslySetInnerHTML={{
              __html: data.vision?.titulo,
            }}
            ></p>
            <p className='vision-info'
              dangerouslySetInnerHTML={{
                __html: data.vision?.texto_completo,
              }}
            ></p>
          </div>
        )}
        {isLoading ? (
          <div className='vision-img-container vision-img-desktop'>
            <ContentLoader
              speed={2}
              width='100%'
              height='auto'
              foregroundColor={colorSecundario}
              backgroundColor={colorQuinto}
            >
              <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
              <rect x='0' y='120%' rx='30' ry='30' width='100%' height='100%' />
            </ContentLoader>
          </div>
        ) : (
          <div className='vision-img-container vision-img-desktop'>
            <img src={data.vision?.imagen} alt='Visión' />
          </div>
        )}
      </div>
      <Politicas
        fontsizemultiplier={fontSizeMultiplier}
        backgrounditem={backgroundNoveno}
        coloritem={colorSecundario}
        backgroundinfo={colorQuinto}
        colorinfo={colorCuarto}
      >
        {isShown && (
          <div className='info-container'>
            <div
              className='info'
              dangerouslySetInnerHTML={{ __html: selected?.texto_contenido }}
            ></div>
          </div>
        )}
        <div className='cont-title-legal'>
          <p className='title-legal'>Información Legal</p>
        </div>
        
        <div className='politicas-container'>
          {politicas.data.map((item) => ( item.texto_tipo === "quienes somos" && 
            <NavLink
              to={
                item.id === 14 ? "/politicasst" : item.id === 12 ? "/politicainstitucional" : item.id === 13 ? "/Politicacalidad" :
                item.id === 16 ? "/politicadatospersonales" :  item.id === 18 ? "/avisoprivacidad" : item.id === 19 ? "/terminosycondiciones" : ""
              }
              className='politica'
              key={item.id}
            >
              <p className='titulo'>{item.texto_titulo}</p>
            </NavLink>
          ))}
        </div>
      </Politicas>
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  background-color: ${(props) => props.backgroundcontainer};

  .nuestra-historia {
    /* outline: 1px solid red; */
    display: grid;
    gap: 1rem;
    grid-template-columns: 1.5fr 1fr;
    align-items: center;
    margin-top: 5vh;
    margin-bottom: 5rem;
    padding: 0 5rem;

    .img-container {
      max-width: 72.8rem;

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .text-container {
      padding: 5rem 2rem 3rem 2rem;

      .subtitle {
        font-size: ${(props) => 14 * props.fontsizemultiplier};
        font-weight: 700;
        letter-spacing: 5px;
        text-transform: uppercase;
        color: ${(props) => props.colorsubtitle};
      }

      .title {
        font-size: ${(props) => 80 * props.fontsizemultiplier};
        color: ${(props) => props.colortitle};
      }

      .info {
        font-size: ${(props) => 16 * props.fontsizemultiplier};
        color: ${(props) => props.colortipografia};
      }
    }
  }

  .historia {
    p {
      font-size: ${(props) => 25 * props.fontsizemultiplier};
      font-weight: 700;
      text-align: center;
      padding-top: 2rem;
      max-width: 60vw;
      margin: 0 auto;
      color: #808080;
    }
  }

  .mision {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1.5fr;
    margin-top: 5rem;
    margin-bottom: 2rem;

    .mision-img-container {
      max-width: 50rem;
      border-top-right-radius: 25rem;
      border-bottom-right-radius: 25rem;
      overflow: hidden;

      img {
        max-width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .mision-text-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: 2rem;

      .mision-title {
        font-size: ${(props) => 70 * props.fontsizemultiplier};
        font-weight: 700;
        color: ${(props) => props.colorsubtitle};
      }

      .mision-info {
        font-size: ${(props) => 16 * props.fontsizemultiplier};
        color: ${(props) => props.colortipografia};
      }
    }
  }

  .vision {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1.5fr 1fr;
    justify-content: space-between;
    margin-top: 5rem;
    margin-bottom: 5rem;

    .vision-img-container {
      max-width: 50rem;
      border-top-left-radius: 25rem;
      border-bottom-left-radius: 25rem;
      margin-left: auto;
      overflow: hidden;

      img {
        max-width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .vision-img-mobile {
      display: none;
    }

    .vision-text-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 5rem;

      .vision-title {
        font-size: ${(props) => 70 * props.fontsizemultiplier};
        font-weight: 700;
        color: ${(props) => props.colorsubtitle};
      }

      .vision-info {
        font-size: ${(props) => 16 * props.fontsizemultiplier};
        color: ${(props) => props.colortipografia};
      }
    }
  }

  .cont-title-legal{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    margin-bottom: 1rem;

    .title-legal{
      font-size: ${(props) => 70 * props.fontsizemultiplier};
      font-weight: 700;
      color: ${(props) => props.colorsubtitle};

      @media (max-width: 800px) {
        font-size: ${(props) => 50 * props.fontsizemultiplier};
      }
    }
  }

  @media (max-width: 1023px) {
    .nuestra-historia {
      grid-template-columns: 1fr;
      margin-bottom: 4rem;
      padding: 0 2rem;

      .img-container {
        margin-bottom: 1rem;
      }

      .text-container {
        padding: 0;

        .title {
          font-size: ${(props) => 60 * props.fontsizemultiplier};
        }

        .info {
          font-size: ${(props) => 20 * props.fontsizemultiplier};
        }
      }
    }

    .historia {
      p {
        max-width: 90vw;
        padding-top: 0;
      }
    }

    .mision {
      grid-template-columns: 1fr;

      .mision-img-container {
        max-width: 95vw;
        min-height: 25vh;
      }

      .mision-text-container {
        padding: 0 2rem;
      }
    }

    .vision {
      grid-template-columns: 1fr;

      .vision-img-container {
        max-width: 95vw;
        min-height: 25vh;
      }

      .vision-text-container {
        padding: 0 2rem;
      }

      .vision-img-desktop {
        display: none;
      }

      .vision-img-mobile {
        display: block;
      }
    }
  }
`;

const Politicas = styled.div`
  .politicas-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
    margin-bottom: 4rem !important;
    padding: 2rem;
    box-shadow: 0px 0px 6px #808080;
    border-radius: 10px;
    width: 95%;
    margin: 0 auto;
  }

  .politica {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 3rem;
    border-radius: 4rem;
    box-shadow: 0px 0px 6px #808080;
    background-color: ${(props) => props.backgrounditem};
    cursor: pointer;

    .titulo {
      font-size: ${(props) => 15 * props.fontsizemultiplier};
      font-weight: 700;
      text-align: center;
      color: ${(props) => props.coloritem};
    }

    &:hover {
      background-color: #05aaaa;

      .titulo {
        color: #fff;
      }
    }
  }

  .info-container {
    position: relative;
    margin-bottom: 1rem;
  }

  .info {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 5;
    width: 97vw;
    margin-left: -48.5vw;
    padding: 2rem;
    border-radius: 3rem;
    -webkit-box-shadow: 0px 0px 40px 5px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 40px 5px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 40px 5px rgba(0,0,0,0.75);
    background-color: ${(props) => props.backgroundinfo};
    color: ${(props) => props.colorinfo};
  }

  @media (max-width: 1023px) {
    .politicas-container {
      gap: 2rem;
    }
  }
`;
